
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Kalyaninagartomumbaitaxiservice() {



    const cardData =
    {
        keyword: 'Kalyani Nagar to Mumbai Taxi Service',
        heading: 'Meghana Cab : Kalyani Nagar to Mumbai Taxi Service',
        headingDescription: 'Meghana Cab offers Kalyani Nagar to Mumbai Taxi Service, delivering a premium and comfortable travel experience from one of Pune’s upscale neighborhoods to Mumbai. Whether you are heading for a business meeting, airport transfer, or leisure trip, our taxi service ensures punctual pickups, smooth rides, and complete peace of mind. Choose from our fleet of Hatchbacks, Sedans, SUVs, and Innova Crysta vehicles—each maintained for your comfort and safety. With transparent pricing, courteous drivers, and 24/7 customer support, book your Kalyani Nagar to Mumbai Taxi with Meghana Cab and enjoy reliable, door-to-door intercity travel.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
   
 {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
   {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Kalyani Nagar to Mumbai Cab Booking",
        "description": "Book your cab from Kalyani Nagar to Mumbai effortlessly with our easy-to-use online platform. We offer a wide range of vehicles, professional drivers, and prompt confirmation to ensure a seamless travel experience."
    },
    {
        "name": "One Way Taxi Kalyani Nagar to Mumbai",
        "description": "Travel hassle-free with our one-way taxi service from Kalyani Nagar to Mumbai. Perfect for airport transfers, business trips, or personal visits, we guarantee timely pickups and comfortable rides."
    },
    {
        "name": "Round Trip Cab Kalyani Nagar to Mumbai",
        "description": "Planning a round trip between Kalyani Nagar and Mumbai? Our reliable round-trip cab service offers flexible schedules, competitive rates, and professional drivers for your convenience."
    },
    {
        "name": "Online Taxi Booking Kalyani Nagar to Mumbai",
        "description": "Book your taxi online from Kalyani Nagar to Mumbai with instant confirmation and multiple payment options. Enjoy a secure and transparent booking process tailored for your convenience."
    },
    {
        "name": "Budget Travel Taxi Kalyani Nagar to Mumbai",
        "description": "Travel economically without compromising on quality. Our budget taxi services from Kalyani Nagar to Mumbai offer clean, fuel-efficient vehicles and reliable service at affordable rates."
    },
    {
        "name": "SUV Hire Kalyani Nagar to Mumbai",
        "description": "Need more space and comfort? Hire an SUV taxi from Kalyani Nagar to Mumbai, ideal for families or groups with extra luggage, ensuring a smooth and spacious journey."
    },
    {
        "name": "AC Sedan Taxi Kalyani Nagar to Mumbai",
        "description": "Experience comfort and style with our air-conditioned sedan taxis from Kalyani Nagar to Mumbai. Perfect for business travelers and individuals seeking a relaxing ride."
    },
    {
        "name": "Private Driver Cab Kalyani Nagar to Mumbai",
        "description": "Enjoy personalized service with our private driver cabs from Kalyani Nagar to Mumbai. Our experienced chauffeurs prioritize your comfort, privacy, and safety throughout the trip."
    },
    {
        "name": "Family Trip Taxi Kalyani Nagar to Mumbai",
        "description": "Make your family trip enjoyable and safe with our spacious and well-maintained family cabs from Kalyani Nagar to Mumbai. Our drivers are courteous and experienced in handling family travel needs."
    },
    {
        "name": "Chauffeur Cab Kalyani Nagar to Mumbai",
        "description": "Opt for a chauffeur-driven cab from Kalyani Nagar to Mumbai for a premium travel experience. Our professional drivers ensure a smooth ride, punctuality, and excellent customer service."
    },
    {
        "name": "Fast Taxi Service Kalyani Nagar to Mumbai",
        "description": "In a rush? Our fast taxi service from Kalyani Nagar to Mumbai offers quick booking, prompt pickups, and efficient routes to get you to your destination on time."
    },
    {
        "name": "Reliable Cabs Kalyani Nagar to Mumbai",
        "description": "Depend on our reliable taxi services from Kalyani Nagar to Mumbai for consistent on-time arrivals, clean vehicles, and courteous drivers who prioritize your comfort and safety."
    },
    {
        "name": "Business Travel Taxi Kalyani Nagar to Mumbai",
        "description": "Make your corporate travel seamless with our business taxi service from Kalyani Nagar to Mumbai. We offer professional chauffeurs, timely pickups, and convenient billing options for business clients."
    },
    {
        "name": "Quick Cab Kalyani Nagar to Mumbai",
        "description": "Book a quick cab from Kalyani Nagar to Mumbai with just a few clicks. Our streamlined process ensures instant confirmation and reliable service for last-minute travel plans."
    },
    {
        "name": "24/7 Taxi Kalyani Nagar to Mumbai",
        "description": "Our 24/7 taxi service from Kalyani Nagar to Mumbai is available round the clock to cater to your travel needs at any time, including early morning flights and late-night arrivals."
    }
],
"tableData": [
    ["Kalyani Nagar to Mumbai Cab Booking", "One Way Taxi Kalyani Nagar to Mumbai"],
    ["Round Trip Cab Kalyani Nagar to Mumbai", "Online Taxi Booking Kalyani Nagar to Mumbai"],
    ["Budget Travel Taxi Kalyani Nagar to Mumbai", "SUV Hire Kalyani Nagar to Mumbai"],
    ["AC Sedan Taxi Kalyani Nagar to Mumbai", "Private Driver Cab Kalyani Nagar to Mumbai"],
    ["Family Trip Taxi Kalyani Nagar to Mumbai", "Chauffeur Cab Kalyani Nagar to Mumbai"],
    ["Fast Taxi Service Kalyani Nagar to Mumbai", "Reliable Cabs Kalyani Nagar to Mumbai"],
    ["Business Travel Taxi Kalyani Nagar to Mumbai", "Quick Cab Kalyani Nagar to Mumbai"],
    ["24/7 Taxi Kalyani Nagar to Mumbai", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Taxi Service from Kalyani Nagar to Mumbai",
        "WhyChoosedescription": "Our Kalyani Nagar to Mumbai taxi service ensures on-time pickups and smooth, uninterrupted travel. Whether you're commuting for work, a weekend getaway, or an airport drop, we offer dependable and professional service every time."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles for Every Journey",
        "WhyChoosedescription": "Travel in well-maintained, sanitized vehicles with modern amenities such as air-conditioning, plush seating, and ample space for luggage. Our fleet includes sedans, SUVs, and premium cars to match your comfort needs and budget."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our trained drivers are professional, polite, and well-versed with the Kalyani Nagar–Mumbai route. They ensure a safe, pleasant, and timely journey while maintaining complete respect for your privacy and preferences."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy competitive fares with complete transparency. Our pricing includes fuel, tolls, taxes, and driver allowances, so you know exactly what you're paying for—no last-minute surprises or hidden fees."
    },
    {
        "WhyChooseheading": "Flexible Booking for One-Way, Round Trips, and Hourly Rides",
        "WhyChoosedescription": "Book a cab the way you need it—be it a one-way trip to Mumbai, a round trip, or an hourly rental. We offer flexible travel options with customizable pickup and drop-off locations tailored to your schedule."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off for Maximum Convenience",
        "WhyChoosedescription": "Avoid the hassle of commuting to a taxi stand. We pick you up from your doorstep in Kalyani Nagar and drop you off exactly where you need to be in Mumbai—offering a smooth, end-to-end ride."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Business Trips, and City Travel",
        "WhyChoosedescription": "Our Kalyani Nagar to Mumbai taxis are ideal for airport runs, work travel, family visits, or leisure. With punctual service and a relaxing ride, we help you travel without stress or delays."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Customer Assistance",
        "WhyChoosedescription": "Need help with your booking or have a last-minute change? Our customer support is available 24/7 to assist with reservations, cancellations, or special requests, ensuring a smooth and reliable experience from start to finish."
    }
]
























    }

const faqData = [
    {
        question: "How do I book a taxi from Kalyani Nagar to Mumbai?",
        answer: "You can book a taxi by calling Meghana Cab at +91 9075462128 or via our website for quick and secure booking."
    },
    {
        question: "What is the estimated travel time from Kalyani Nagar to Mumbai by taxi?",
        answer: "The trip usually takes around 3 to 4 hours, depending on traffic and road conditions."
    },
    {
        question: "Are both one way and round trip taxi services available from Kalyani Nagar to Mumbai?",
        answer: "Yes, we offer both one way and round trip options to suit your travel requirements."
    },
    {
        question: "What types of taxis are available for the Kalyani Nagar to Mumbai route?",
        answer: "You can choose from hatchbacks, sedans, SUVs, and tempo travellers based on your group size."
    },
    {
        question: "Is the taxi service available 24/7 from Kalyani Nagar to Mumbai?",
        answer: "Yes, Meghana Cab operates round the clock to accommodate your schedule."
    },
    {
        question: "Does the fare include all charges like tolls, fuel, and driver fees?",
        answer: "Yes, the fare includes fuel, tolls, and driver charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Can I book a taxi from Kalyani Nagar to Mumbai on short notice?",
        answer: "Yes, last-minute bookings are accepted subject to vehicle availability. Please call for urgent requests."
    },
    {
        question: "Is online booking available for Kalyani Nagar to Mumbai taxi service?",
        answer: "Yes, you can conveniently book online anytime through our website."
    },
    {
        question: "Can I request stops during the journey for food or breaks?",
        answer: "Yes, stops can be arranged upon request. Please inform us while booking or notify the driver."
    },
    {
        question: "Are your drivers experienced and knowledgeable about the Kalyani Nagar to Mumbai route?",
        answer: "Absolutely. Our drivers are professional and familiar with the best routes to ensure a safe and timely journey."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Anil Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The taxi service from Kalyani Nagar to Mumbai was excellent. The driver was punctual and the ride was comfortable.”',
    },
    {
        name: 'Ms. Sneha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booking a taxi online was simple and quick. Meghana Cab provided a hassle-free experience from Kalyani Nagar to Mumbai.”',
    },
];























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kalyani Nagar to Mumbai Taxi Service",
  "image": "https://www.meghanacabs.com/assets/images/kalyani-nagar-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable taxi service from Kalyani Nagar to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Available for one-way and round trips with 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/kalyani-nagar-to-mumbai-taxi-service"
  }
};





    return (
        <div>
<Helmet>
  <title>Kalyani Nagar to Mumbai Taxi Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable and reliable taxi service from Kalyani Nagar to Mumbai by Meghana Cabs. Book AC Sedans, SUVs, or chauffeur-driven cars online. Available 24/7 for one-way and round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Kalyani Nagar to Mumbai Cab Booking, One Way Taxi Kalyani Nagar to Mumbai, Round Trip Cab Kalyani Nagar to Mumbai, Online Taxi Booking Kalyani Nagar to Mumbai, Budget Travel Taxi Kalyani Nagar to Mumbai, SUV Hire Kalyani Nagar to Mumbai, AC Sedan Taxi Kalyani Nagar to Mumbai, Private Driver Cab Kalyani Nagar to Mumbai, Family Trip Taxi Kalyani Nagar to Mumbai, Chauffeur Cab Kalyani Nagar to Mumbai, Fast Taxi Service Kalyani Nagar to Mumbai, Reliable Cabs Kalyani Nagar to Mumbai, Business Travel Taxi Kalyani Nagar to Mumbai, Quick Cab Kalyani Nagar to Mumbai, 24/7 Taxi Kalyani Nagar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kalyaninagartomumbaitaxiservice;